export interface ImageCategoryLabel {
  code: string;
  nameEn?: string | null;
  nameZh?: string | null;
  score: number;
  rank: number;
}

export interface ImageCategoryOption {
  code: string;
  nameEn?: string | null;
  nameZh?: string | null;
  imageCount: number;
}

export interface ImageCategoryItem {
  resultId: number;
  uploadId: number;
  fileName: string;
  directory?: string | null;
  imageUrl?: string | null;
  rawImageUrl?: string | null;
  contentType: string;
  uploadTime: string;
  classificationTime?: string | null;
  labels: ImageCategoryLabel[];
}

export interface ImageCategoryPage {
  page: number;
  total: number;
  data: ImageCategoryItem[];
}

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  code?: string;
  data?: T;
}

export class ImageCategoryApiError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'ImageCategoryApiError';
    this.code = code;
  }
}

const request = async <T>(url: string): Promise<T> => {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  const body = await response.json() as ApiResponse<T>;
  if (!response.ok || !body.success || body.data === undefined) {
    throw new ImageCategoryApiError(body.message || 'Failed to load image categories', body.code);
  }
  return body.data;
};

export const getImageCategoryOptions = (): Promise<ImageCategoryOption[]> =>
  request<ImageCategoryOption[]>('/img/image-categories/options');

export const getImageCategories = (
  page: number,
  pageSize: number,
  tagCodes: string[],
): Promise<ImageCategoryPage> => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  tagCodes.forEach((code) => params.append('tagCodes', code));
  return request<ImageCategoryPage>(`/img/image-categories?${params.toString()}`);
};
